import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import { ILoginWithOtpPayload } from '@app-store/slices/auth/loginWithOtp.slice'
import { loginWithOtpCognitoUser } from '@utils/authenticateService'
import { successLogin } from '@utils/helpers/authHelper'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: ILoginWithOtpPayload
}

const { onFailure, onRequest } = rootActions.auth.loginWithOtp

function* loginWithOtp({ payload }: TaskAction) {
    try {
        const loginValues = {
            email: payload.email,
            code: payload.code,
            cognitoUser: payload.cognitoUser
        }
        const response = yield loginWithOtpCognitoUser(loginValues)
        yield successLogin(response, payload?.sagaCB)
    } catch (e) {
        yield put(onFailure('Email or code is incorrect'))
    }
}

function* loginWithOtpSaga(): any {
    yield takeLatest<TaskAction>(onRequest, loginWithOtp)
}

export default loginWithOtpSaga
